<template>
  <v-dialog v-model="showCookies" width="500" scrollable>
    <v-card>
      <v-card-title>Cookies</v-card-title>
      <v-card-text class="cookies__text">
        <p>
          Nasza strona internetowa wykorzystuje tzw. cookies, tj. informacje
          zapisywane przez serwery na urządzeniu końcowym użytkownika, czyli np.
          Twoim komputerze, kt&oacute;re mogą być odczytane przy każdorazowym
          połączeniu się z tego urządzenia końcowego. Pliki cookies (tzw.
          &bdquo;ciasteczka&rdquo;) stanowią dane informatyczne, w
          szczeg&oacute;lności pliki tekstowe, kt&oacute;re przechowywane są w
          urządzeniu końcowym użytkownika serwisu internetowego. Cookies
          zazwyczaj zawierają nazwę domeny serwisu internetowego, z
          kt&oacute;rego pochodzą, czas przechowywania ich na urządzeniu
          końcowym oraz unikalny numer.
        </p>
        <p><b>1. Pliki cookies wykorzystywane są w celu:</b></p>
        <p>
          a) dostosowania zawartości stron serwis&oacute;w internetowych do
          preferencji użytkownika oraz optymalizacji korzystania ze stron
          internetowych; w szczeg&oacute;lności pliki te pozwalają rozpoznać
          urządzenie użytkownika serwisu internetowego i odpowiednio wyświetlić
          stronę internetową, dostosowaną do jego indywidualnych potrzeb,
        </p>
        <p>
          b) tworzenia statystyk, kt&oacute;re pomagają zrozumieć, w jaki
          spos&oacute;b użytkownicy serwisu korzystają ze stron internetowych,
          co umożliwia ulepszanie ich struktury i zawartości,
        </p>
        <p>
          c) utrzymania sesji użytkownika serwisu internetowego (po
          zalogowaniu), dzięki kt&oacute;rej użytkownik nie musi na każdej
          podstronie serwisu ponownie wpisywać loginu i hasła,
        </p>
        <p>
          d) dostarczania użytkownikom treści reklamowych bardziej dostosowanych
          do ich zainteresowań.
        </p>
        <p>
          <b
            >2. W ramach mojego bloga mogą być stosowane następujące rodzaje
            plik&oacute;w cookies:</b
          >
        </p>
        <p>
          a) &bdquo;niezbędne&rdquo; pliki cookies, umożliwiające korzystanie z
          usług dostępnych w ramach serwisu internetowego, np. uwierzytelniające
          pliki cookies wykorzystywane do usług wymagających uwierzytelniania w
          ramach serwisu,
        </p>
        <p>
          b) pliki cookies służące do zapewnienia bezpieczeństwa, np.
          wykorzystywane do wykrywania nadużyć w zakresie uwierzytelniania w
          ramach serwisu,
        </p>
        <p>
          c) pliki cookies, umożliwiające zbieranie informacji o sposobie
          korzystania ze stron internetowych serwisu,
        </p>
        <p>
          d) &bdquo;funkcjonalne&rdquo; pliki cookies, umożliwiające
          &bdquo;zapamiętanie&rdquo; wybranych przez użytkownika ustawień i
          personalizację interfejsu użytkownika, np. w zakresie wybranego języka
          lub regionu, z kt&oacute;rego pochodzi użytkownik, rozmiaru czcionki,
          wyglądu strony internetowej itp.,
        </p>
        <p>
          e) &bdquo;reklamowe&rdquo; pliki cookies, umożliwiające dostarczanie
          użytkownikom treści reklamowych bardziej dostosowanych do ich
          zainteresowań.
        </p>
        <p>
          <b
            >3. W wielu przypadkach oprogramowanie służące do przeglądania stron
            internetowych (przeglądarka internetowa)</b
          >&nbsp;domyślnie dopuszcza przechowywanie plik&oacute;w cookies w
          urządzeniu końcowym użytkownika. Użytkownicy bloga mogą dokonać w
          każdym czasie zmiany ustawień dotyczących plik&oacute;w cookies.
          Ustawienia te mogą zostać zmienione w szczeg&oacute;lności w taki
          spos&oacute;b, aby blokować automatyczną obsługę plik&oacute;w cookies
          w ustawieniach przeglądarki internetowej bądź informować o ich
          każdorazowym zamieszczeniu w urządzeniu użytkownika serwisu
          internetowego. Szczeg&oacute;łowe informacje o możliwości i sposobach
          obsługi plik&oacute;w cookies dostępne są w ustawieniach
          oprogramowania (przeglądarki internetowej). Niedokonanie zmiany
          ustawień w zakresie cookies oznacza, że będą one zamieszczone w
          urządzeniu końcowym użytkownika, a tym samym będziemy przechowywać
          informacje w urządzeniu końcowym użytkownika i uzyskiwać dostęp do
          tych informacji.
        </p>
        <p>
          <b
            >4. Wyłączenie stosowania cookies może spowodować utrudnienia
            korzystanie z niekt&oacute;rych usług w ramach mojej strony,</b
          >&nbsp;w szczeg&oacute;lności wymagających logowania. Wyłączenie opcji
          przyjmowania cookies nie powoduje natomiast braku możliwości czytania
          lub oglądania treści zamieszczanych w serwisie internetowym jakim jest
          ten Blog z zastrzeżeniem tych, do kt&oacute;rych dostęp wymaga
          logowania.
        </p>
        <p>
          Zastrzegam sobie możliwość wprowadzania zmian w niniejszej Polityce
          Prywatności.
        </p>
        <p>
          W razie wątpliwości, co do obecnej Polityki Prywatności, proszę o
          wiadomość na adres: d.michalak@dmkancelaria.pl
        </p>
      </v-card-text>
      <v-card-actions class="text-center">
        <div class="cookies__actions">
          <v-btn color="accent" @click="accept">Akceptuję</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Cookies',
  data() {
    return {
      showCookies: true,
    };
  },
  watch: {
    showCookies(value) {
      this.SET_HEADER_STATE(!value);
    },
  },
  methods: {
    ...mapMutations(['SET_HEADER_STATE']),
    accept() {
      this.showCookies = false;
    },
  },
};
</script>

<style scoped>
.cookies__text {
  height: 400px;
  text-align: justify;
}
.cookies__actions {
  width: 100%;
}
</style>
